import React, { useState } from 'react';
import { Box, Typography, TextField, Button, Paper, Dialog } from '@mui/material';
import styles from './ChangePassword.module.scss';
import { useAppDispatch } from '~/redux/hooks';
import { notify } from '~/utils/helper';
import { handleChangePassword } from '~/thunks/auth/changePasswordThunk';

interface ChangePasswordProps {
  open: boolean;
  onClose: () => void;
}

const ChangePassword = ({ open, onClose }: ChangePasswordProps) => {
  const dispatch = useAppDispatch();
  const [formData, setFormData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
  });

  const handleInputChange = (field: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [field]: event.target.value,
    });
  };

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();

    if (formData.newPassword !== formData.confirmPassword) {
      notify('error', 'Passwords do not match');
      return;
    }

    if (formData.newPassword.length < 8) {
      notify('error', 'Password must be at least 8 characters');
      return;
    }
    try {
      const result = await dispatch(
        handleChangePassword({
          oldPassword: formData.currentPassword,
          newPassword: formData.newPassword,
        })
      ).unwrap();
      notify('success', result.message || 'Password changed successfully!');
      setFormData({
        currentPassword: '',
        newPassword: '',
        confirmPassword: '',
      });
      onClose();
    } catch (err: any) {
      notify('error', err?.message || 'Failed to change password');
    }
  };
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      PaperProps={{
        sx: { 
          backgroundColor: '#11233F',
          overflow: 'hidden'
        }
      }}
    >
      <Box className={styles.changePassword}>
      <Typography variant='h4' className={styles.title}>
        Change Password
      </Typography>
      <Typography variant='body1' className={styles.description}>
        Update your account password
      </Typography>
      <Paper className={styles.formContainer}>
        <Box component='form' onSubmit={handleSubmit} className={styles.form}>
          <Typography className={styles.fieldLabel}>Current Password</Typography>
          <TextField
            fullWidth
            type="password"
            placeholder='Enter current password'
            value={formData.currentPassword}
            onChange={handleInputChange('currentPassword')}
            margin='none'
            required
            className={styles.formField}
          />
          <Typography className={styles.fieldLabel}>New Password</Typography>
          <TextField
            fullWidth
            type="password"
            placeholder='Enter new password'
            value={formData.newPassword}
            onChange={handleInputChange('newPassword')}
            margin='none'
            required
            className={styles.formField}
          />
          <Typography className={styles.fieldLabel}>Confirm New Password</Typography>
          <TextField
            fullWidth
            type="password"
            placeholder='Confirm new password'
            value={formData.confirmPassword}
            onChange={handleInputChange('confirmPassword')}
            margin='none'
            required
            className={styles.formField}
          />
        <Box className={styles.buttonContainer}>
          <Button
            type='submit'
            variant='contained'
            className={styles.submitButton}
          >
            Change Password
          </Button>
        </Box>
      </Box>
      </Paper>
      </Box>
    </Dialog>
  );
};

export default ChangePassword;
   